const Error=()=>{
  return(
    <div className="flex text-white text-3xl justify-center items-center">
      Error - 404 Not found
    </div>
  );
}

export default Error;